import { IntroBox } from '@/warranty-v3/components/intro-box';

export function ConditionViolationsIntroBox() {
  const detailedContent = (
    <>
      <p>
        This section monitors violations of critical operational conditions —
        thresholds that, if exceeded, put your entire warranty coverage at risk.
      </p>

      <p>
        <strong>Condition Violations</strong> include severe or prolonged
        breaches of warranty rules, such as excessive throughput or unmitigated
        temperature spikes. Unlike penalty points (which reduce coverage), these
        violations can <strong>fully void the warranty </strong> for affected
        units or sites.
      </p>

      <ul className="list-inside list-disc space-y-1">
        <li>
          Typically tied to <strong>"hard stop" limits</strong> set by the
          supplier.
        </li>
        <li>
          Can affect a small number of units or escalate across multiple
          racks/sites if systemic.
        </li>
        <li>
          Often require formal remediation, root cause analysis, or supplier
          review.
        </li>
      </ul>

      <p className="text-muted-foreground">
        Continuous monitoring and early warnings help avoid these violations and
        preserve full warranty protection.
      </p>
    </>
  );

  return (
    <IntroBox
      title="Condition Violations"
      dialogTitle="Critical Condition Violations"
      dialogDescription="Monitoring serious breaches that risk full warranty invalidation."
      detailedContent={detailedContent}
    >
      represent breaches that <em>may lead to warranty invalidation</em>. These
      events cross hard thresholds defined in your warranty conditions and
      require immediate attention.
    </IntroBox>
  );
}
